import { render, staticRenderFns } from "./myPageListDetail.vue?vue&type=template&id=4e06bdaa&scoped=true&"
import script from "./myPageListDetail.vue?vue&type=script&lang=js&"
export * from "./myPageListDetail.vue?vue&type=script&lang=js&"
import style0 from "./myPageListDetail.vue?vue&type=style&index=0&id=4e06bdaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06bdaa",
  null
  
)

export default component.exports